<template>
    <div @click="$emit('click')" v-if="user.profile" class="user-profile">
        <UserInfoBasic class="m-b-4" :user="user" :hideBookmark="hideBookmark" :hide-memo="hideMemo" />
        <div class="basic-info flex-row">
            <span class="info flex-wrap" v-html="`${$options.filters.asAge(user.profile.birthday)}세`" />
            <span class="divider flex-wrap" v-html="'ㅣ'" />
            <span class="info flex-wrap" v-html="`${user.profile.height}cm`" />
            <span class="divider flex-wrap" v-html="'ㅣ'" />
            <span class="info flex-wrap" v-html="user.profile.region_name" />
            <span class="divider flex-wrap" v-html="'ㅣ'" />
            <span class="info flex-wrap" v-html="`${user.profile.hometown_name || '-'}(고향)`" />
            <Distance v-if="!hideDistance" class="flex-wrap m-l-8" :distance="user.$$distance" />
        </div>
        <div class="hr" :class="gender" />
        <div class="job flex-row items-center">
            <i class="zmdi zmdi-case flex-wrap" />
            <div class="hor-separated c-text-dark flex-wrap">
                <span>{{ user.profile.job_name }}</span>
                <span v-if="company && company != 'null'" v-html="company" />
            </div>
            <i v-if="user.profile.company_verified" class="badge badge-verified zmdi zmdi-check flex-wrap m-l-4" />
        </div>

        <div class="school flex-row items-center">
            <i class="zmdi zmdi-city flex-wrap" v-if="!user.profile.is_student" />
            <div class="c-text-dark flex-wrap" v-if="!user.profile.is_student">
                {{ user.profile | school }}
            </div>
            <i v-if="user.profile.university_verified" class="badge badge-verified zmdi zmdi-check flex-wrap m-l-4" />
        </div>

        <div class="income flex-row items-center">
            <!-- <i class="zmdi zmdi-money flex-wrap" /> -->
            <i class="flex-wrap material-icons-outlined material-money"> attach_money </i>
            <div class="hor-separated c-text-dark flex-wrap">
                <span>{{ user.profile.income }}(연소득)</span>
                <!-- <span v-html="company ? company : ''" /> -->
                <span>{{ user.profile.asset }}(자산)</span>
            </div>
            <i v-if="user.profile.company_verified" class="badge badge-verified zmdi zmdi-check flex-wrap m-l-4" />
        </div>

        <NoOnsCampaignBadge v-if="user.$$chatId" :user="user" />
        <div @click="onClickPremiumComment" v-if="user.$$premium && myPremium" class="create-comment">코멘트 작성</div>

        <Kinds
            :isPremium="!!user.$$premium"
            v-if="hideKinds === null || hideKinds === undefined || hideKinds === false"
            :hideKey="hideKey"
            :profile="user.profile"
        />
    </div>
</template>

<script>
import UserInfoBasic from '@/components/common/UserInfoBasic'
import Kinds from '@/components/common/Kinds'
import NoOnsCampaignBadge from '@/components/common/NoOnsCampaignBadge'

export default {
    name: 'UserProfile',
    props: ['user', 'chat', 'hideDistance', 'hideKey', 'hideKinds', 'hideBookmark', 'hideMemo'],
    components: { UserInfoBasic, Kinds, NoOnsCampaignBadge },
    computed: {
        gender() {
            return this.$options.filters.gender(this.user.gender)
        },
        company() {
            console.log('69 : ', this.user.profile, this.$options.filters.company(this.user.profile))
            return this.$options.filters.company(this.user.profile)
        },
        myPremium() {
            if (this.user.$$premium) {
                const premium = this.$options.filters.hasProduct(this.user, 'premium')
                return this.$store.getters.agent.id === premium.agent_id
            }
            return false
        },
    },
    methods: {
        onClickPremiumComment() {
            this.$modal.custom({
                component: 'ModalPremiumComment',
                options: {
                    agent_intro: (this.user.$$premium || {}).premium_info.agent_intro,
                },
            })
        },
        banCampaign() {
            // userService.banNoOnsCampaign(this.user.id)
            //     .then(res => console.log(res))
        },
    },
}
</script>

<style lang="scss" scoped>
.kinds {
    margin-left: -150px;
    margin-top: 40px;

    &.isPremium {
        margin-top: 10px;
    }
}
.school,
.income {
    height: 16px;
}
</style>
